// Auth
import Login from "../pages/auth/login";
import Register from "../pages/auth/register";

//Private
import Resources from "../pages/resources";
import Works from "../pages/works";
import About from "../pages/about";
import Settings from "../pages/settings";
import Leadership from "../pages/leadership";

import NotFound from "../pages/not-found";
import Testimony from "../pages/testimony";

const routes = [
  {
    name: "Login",
    path: "/",
    icon: "",
    component: <Login />,
    type: 'public',
    permissions: [],
    showInMenu: false,
  },
  {
    name: "Login",
    path: "/login",
    icon: "",
    component: <Login />,
    type: 'public',
    permissions: [],
    showInMenu: false,
  },
  {
    name: "Register",
    path: "/register",
    icon: "",
    component: <Register />,
    type: 'public',
    permissions: [],
    showInMenu: false,
  },
  {
    name: "Resources",
    path: "resources",
    icon: "fa-folder",
    component: <Resources />,
    type: 'private',
    permissions: ['admin', 'employee'],
    showInMenu: true,
  },
  {
    name: "Works",
    path: "work",
    icon: "fa-briefcase",
    component: <Works />,
    type: 'private',
    permissions: ['admin'],
    showInMenu: true,
  },
  {
    name: "Testimony",
    path: "testimony",
    icon: "fa-comment",
    component: <Testimony />,
    type: 'private',
    permissions: ['admin'],
    showInMenu: true,
  },
  {
    name: "Media",
    path: "about-us",
    icon: "fa-images",
    component: <About />,
    type: 'private',
    permissions: ['admin', 'employee'],
    showInMenu: true,
  },
  {
    name: "Leadership",
    path: "leadership",
    icon: "fa-users",
    component: <Leadership />,
    type: 'private',
    permissions: ['admin'],
    showInMenu: true,
  },
  {
    name: "Profile",
    path: "settings",
    icon: "fa-user",
    component: <Settings />,
    type: 'private',
    permissions: ['admin', 'employee'],
    showInMenu: true,
  },
  {
    name: "Error 404",
    path: "*",
    icon: "",
    component: <NotFound />,
    type: 'public',
    permissions: [],
    showInMenu: false,
  }
];

export default routes;
